import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { TaskWorkflowByProfile } from "../../core/model/task-workflow-by-profile";
import { Workflow } from "../../core/model/workflow";
import { UserProfile } from "../../core/model/user-profile";
import { ServiceTask } from "../../core/model/serviceTask";
import { Formulaire } from "../../core/model/formulaire";
import { WorkflowService } from "../../core/service/workflow.service";
import { UserProfileService } from "../../core/service/user-profile.service";
import { TaskWorkflowByProfileService } from "../../core/service/task-workflow-by-profile.service";
import { FormulaireService } from "../../core/service/formulaire.service";
import { ServiceService } from "../../core/service/service.service";

@Component({
  selector: "app-edit-task",
  templateUrl: "./edit-task.component.html",
  styleUrls: ["./edit-task.component.scss"],
})
export class EditTaskComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  taskId: number;
  task: TaskWorkflowByProfile;
  workflows: Workflow[];
  profiles: UserProfile[];
  services: ServiceTask[];
  formulaires: Formulaire[];

  constructor(
    private _router: Router,
    private _workflowService: WorkflowService,
    private _userProfileService: UserProfileService,
    private _formulaireService: FormulaireService,
    private _serviceService: ServiceService,
    private _taskWorkflowByProfileService: TaskWorkflowByProfileService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      taskKey: [null, Validators.compose([Validators.required])],
      taskName: [null, Validators.compose([Validators.required])],
      type: [null, Validators.compose([Validators.required])],
      workflow: [null, Validators.compose([Validators.required])],
      userProfile: [null, Validators.compose([Validators.required])],
      service: [null, Validators.compose([Validators.required])],
      formulaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.taskId = params["taskId"];
      this.getTask(this.taskId);
      this.getWorkflows();
      this.getUserProfiles();
      this.getAllServices();
      this.getAllFormulaires();
    });
  }

  getTask(taskId) {
    this.loading = true;
    this._taskWorkflowByProfileService
      .getTaskWorkflowByProfileById(taskId)
      .subscribe(
        (data) => {
          this.task = {
            ...data,
            workflow: data.workflow ? { ...data.workflow } : new Workflow(),
            userProfile: data.userProfile
              ? { ...data.userProfile }
              : new UserProfile(),
            formulaire: data.formulaire
              ? { ...data.formulaire }
              : new Formulaire(),
            serviceTask: data.serviceTask
              ? { ...data.serviceTask }
              : new ServiceTask(),
          };
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
        }
      );
  }

  getWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUserProfiles() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.profiles = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllServices() {
    this._serviceService.getAllServices().subscribe(
      (data) => {
        this.services = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllFormulaires() {
    this._formulaireService.getAllFormulaires().subscribe(
      (data) => {
        this.formulaires = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;

    const selectedWorkflow = (this.workflows || []).find(
      (w) => w.id === this.task.workflow.id
    );
    if (selectedWorkflow) {
      this.task.workflow = { ...selectedWorkflow };
    }
    const selectedProfile = (this.profiles || []).find(
      (p) => p.id === this.task.userProfile.id
    );
    if (selectedProfile) {
      this.task.userProfile = { ...selectedProfile };
    }
    const selectedService = (this.services || []).find(
      (s) => s.id === this.task.serviceTask.id
    );
    if (selectedService) {
      this.task.serviceTask = { ...selectedService };
    }
    const selectedFormulaire = (this.formulaires || []).find(
      (f) => f.id === this.task.formulaire.id
    );
    if (selectedFormulaire) {
      this.task.formulaire = { ...selectedFormulaire };
    }

    this._taskWorkflowByProfileService
      .update(this.task)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/task");
  }
}
